import React, { useEffect, useState } from "react"
import { connect } from "react-redux"
import styled from "styled-components"

const ToggleButtonBlock = (props:any) => {
    const {elmChecked, data, setData, name, isDisabled, prevClick} = props
    const [active, setActive] = useState(false)
    
    useEffect(() => {
        setActive(elmChecked)
    }, [elmChecked]);
    return (
        <ToggleButton>
            <div className="toggle-button-cover">
                <div className="button-cover" onClick={() => {
                    if(prevClick) {
                        prevClick();
                    }
                    if(!isDisabled){
                        setActive(!active); 
                        setData({...data, [name]:!active == true ? 1 : 0})
                    }
                    }}>
                    <div className="button r" id="button-3">
                        <input type="checkbox" checked={active} className="checkbox" />
                        <div className="knobs"></div>
                        <div className="layer"></div>
                    </div>
                </div>
            </div>
        </ToggleButton>
    )
}

const ToggleButton = styled.div`
    .knobs,
    .layer {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    }

    .button {
    position: relative;
    width: 40px;
    height: 22px;
    overflow: hidden;
    }

    .button.r,
    .button.r .layer {
    border-radius: 100px;
    }

    .button.b2 {
    border-radius: 2px;
    }

    .checkbox {
    position: relative;
    width: 100%;
    height: 100%;
    padding: 0;
    margin: 0;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
    }

    .knobs {
    z-index: 2;
    }

    .layer {
    width: 100%;
    background-color: #dfe9ed;
    transition: 0.3s ease all;
    z-index: 1;
    }
    #button-3 .knobs:before {
        content: "";
        position: absolute;
        top: 2px;
        left: 2px;
        width: 18px;
        height: 18px;
        color: #fff;
        background-color: #fff;
        border-radius: 50%;
        transition: 0.3s ease all, left 0.3s cubic-bezier(0.18, 0.89, 0.35, 1.15);
    }

    #button-3 .checkbox:active + .knobs:before {
    width: 30px;
    border-radius: 11px;
    }

    #button-3 .checkbox:checked:active + .knobs:before {
    margin-left: -15px;
    }

    #button-3 .checkbox:checked + .knobs:before {
    content: "";
    left: 20px;
    background-color: #fff;
    }

    #button-3 .checkbox:checked ~ .layer {
    background-color: #48A800;
    }
`
export default connect()(ToggleButtonBlock)